import gql from 'graphql-tag';

const GET_SPONSORS = gql`
  {
    premiums: sponsors(type: "premium") {
      ...getItems
    }
    masters: sponsors(type: "master") {
      ...getItems
    }
    goldens: sponsors(type: "gold") {
      ...getItems
    }
    standards: sponsors(type: "standard") {
      ...getItems
    }
    supports: sponsors(type: "support") {
      ...getItems
    }
  }

  fragment getItems on Sponsors {
    items {
        id
        image
        name
    }
  }`
;

export default GET_SPONSORS;



/** WEBPACK FOOTER **
 ** ./src/graphql/GET_SPONSORS.js
 **/